/**
 * Utility for standardizing date formats across the UI.
 * Database/API logic should continue to use YYYY-MM-DD.
 */

export function formatDateEU(value) {
  if (!value) return '';

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value; // Fallback to original string if not a valid date
  }

  // Standard European format: DD/MM/YYYY
  return date.toLocaleDateString('el-GR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatDateTimeEU(value) {
  if (!value) return '';

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  // Standard European format: DD/MM/YYYY HH:MM
  return date.toLocaleString('el-GR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}